import styled from "styled-components";

export const StyledList = styled.div`
  ul {
    margin-top: 0;
    padding-left: 27px;
  }
  p,
  li {
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
  }
  p {
    margin-bottom: 0;
  }
`;
